const node_env = process.env.REACT_APP_NODE_ENV;
const open_api = process.env.REACT_APP_OPEN_API;

export {
    node_env,
    open_api
};